import React from 'react';

export const Toggle = ({ checked, onChange, disabled, label }) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked === true}
        aria-label={label}
        className={`toggle ${checked ? 'on' : 'off'}`}
        disabled={disabled === true}
        onClick={() => !disabled && onChange(!checked)}
    >
        <span className="toggle-track">
            <span className="toggle-thumb" />
        </span>
    </button>
);

export default Toggle;
